import { useQuery } from "@tanstack/react-query";
import { getEcomEventsMonthService, type EventsEcomMonthResponse } from "../services/getEventEcomEventService";

export function useGetEcomEventMonth(month: string) {
  return useQuery<EventsEcomMonthResponse, Error>({
    queryKey: ["ecom-events-by-month", month],
    queryFn: () => getEcomEventsMonthService(month),
    
  });
}